// 포인트 + 상점 인벤토리(localStorage, 기기별). 포인트는 누적, 구매 아이템은 영구 보유.
// 챌린지 점수의 10%를 포인트로 적립 → 상점에서 소비 아이템 구매.

const KEY = 'tenblock_shop'

export interface ShopItemDef {
  key: string
  name: string
  emoji: string
  price: number
  usage: 'equip' | 'ingame' | 'auto'
  desc: string
}

// 판매 아이템. usage: 'equip'=대기실에서 장착(포인트2배만), 'ingame'=게임 중 버튼으로 사용,
// 'auto'=게임오버 시 사용 여부를 묻는 프롬프트(부활).
export const SHOP_ITEMS: ShopItemDef[] = [
  { key: 'time', name: '시간 +15초', emoji: '⏰', price: 300, usage: 'ingame', desc: '게임 중 시간 +15초' },
  { key: 'point2x', name: '포인트 2배', emoji: '✨', price: 1500, usage: 'equip', desc: '이번 게임 포인트 적립 2배' },
  { key: 'revive', name: '부활', emoji: '❤️', price: 1000, usage: 'auto', desc: '게임오버 시 1회 부활(시간 풀충전)' },
  { key: 'shuffle', name: '셔플', emoji: '🔀', price: 800, usage: 'ingame', desc: '게임 중 보드를 새로 섞기' },
  { key: 'hammer', name: '망치', emoji: '🔨', price: 100, usage: 'ingame', desc: '게임 중 블록 1개를 제거' },
  { key: 'hint', name: '힌트', emoji: '💡', price: 500, usage: 'ingame', desc: '게임 중 합10 조합을 보여줌' },
  { key: 'bomb', name: '폭탄', emoji: '💣', price: 1200, usage: 'ingame', desc: '남은 블럭을 모두 터뜨리고 다음 스테이지로 (점수 없음)' },
]

type State = { points: number; inv: Record<string, number> }

function load(): State {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) {
      const s = JSON.parse(raw) as State
      return { points: Math.max(0, s.points || 0), inv: s.inv || {} }
    }
  } catch { /* ignore */ }
  return { points: 0, inv: {} }
}

function save(s: State) {
  try { localStorage.setItem(KEY, JSON.stringify(s)) } catch { /* ignore */ }
}

export function getPoints(): number {
  return load().points
}

/** 챌린지 점수의 10%(× 배수)를 포인트로 적립. 적립된 양 반환(없으면 0). */
export function awardPoints(score: number, mult = 1): number {
  const gain = Math.floor(Math.max(0, score) * 0.1) * mult
  if (gain <= 0) return 0
  const s = load()
  s.points += gain
  save(s)
  return gain
}

export function getItemCount(key: string): number {
  return load().inv[key] || 0
}

/** 구매: 포인트가 충분하면 차감 후 인벤토리 +1, 성공 시 true. */
export function buyItem(key: string, price: number): boolean {
  const s = load()
  if (s.points < price) return false
  s.points -= price
  s.inv[key] = (s.inv[key] || 0) + 1
  save(s)
  return true
}

/** 사용: 보유 시 1개 차감, 성공 시 true. */
export function useShopItem(key: string): boolean {
  const s = load()
  if ((s.inv[key] || 0) <= 0) return false
  s.inv[key] -= 1
  save(s)
  return true
}
